import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LOAN,
  DELETE_LOAN,
  UPDATE_LOAN,
  ADD_NEW_LOAN,
} from "./actionType";

import {
  getLoanSuccess,
  getLoanFail,
  deleteLoanSuccess,
  deleteLoanFail,
  updateLoanSuccess,
  updateLoanFail,
  addLoanSuccess,
  addLoanFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveLoanApi,
  getLoanApi,
  updateLoanApi,
  deleteLoanApi,
  addNewLoanApi
} from "../../helpers/backend_helper";

function* getLoan({ payload: loan }) {
  try {
    const response = yield call(getLoanApi, loan);
    yield put(getLoanSuccess(GET_LOAN, response.data));
  } catch (error) {
    yield put(getLoanFail(GET_LOAN, error));
  }
}

function* onUpdateLoan({ payload: loan }) {
  try {
    if (loan.setApprove) {
      const response = yield call(approveLoanApi, loan);
      yield put(updateLoanSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateLoanApi, loan);
      yield put(updateLoanSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateLoanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLoan({ payload: loan }) {
  try {
    const response = yield call(deleteLoanApi, loan);
    yield put(deleteLoanSuccess({ loan, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLoanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLoan({ payload: loan }) {
  try {
    const response = yield call(addNewLoanApi, loan);
    yield put(addLoanSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLoanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLoan() {
  yield takeEvery(GET_LOAN, getLoan);
}

export function* watchUpdateLoan() {
  yield takeEvery(UPDATE_LOAN, onUpdateLoan);
}

export function* watchDeleteLoan() {
  yield takeEvery(DELETE_LOAN, onDeleteLoan);
}

export function* watchAddNewLoan() {
  yield takeEvery(ADD_NEW_LOAN, onAddNewLoan);
}

function* loanSaga() {
  yield all([
    fork(watchGetLoan),
    fork(watchDeleteLoan),
    fork(watchUpdateLoan),
    fork(watchAddNewLoan)
  ]);
}

export default loanSaga;
